import React from 'react';

const GoogleDriveIcon: React.FC = () => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.467 9.17969L10.667 0.179688H5.333L10.133 9.17969H15.467ZM4.747 1.20569L0 9.51269L2.667 14.1797L7.322 6.03369L4.747 1.20569ZM6.104 10.1797L3.818 14.1797H13.5L16 10.1797H6.104Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default GoogleDriveIcon;
